export enum SkinPart {
    HEAD = "head",
    BODY = "body",
    RIGHT_ARM = "rightArm",
    LEFT_ARM = "leftArm",
    RIGHT_LEG = "rightLeg",
    LEFT_LEG = "leftLeg",

    HAT = "hat",
    JACKET = "jacket",
    RIGHT_SLEEVE = "rightSleeve",
    LEFT_SLEEVE = "leftSleeve",
    RIGHT_TROUSERS = "rightTrousers",
    LEFT_TROUSERS = "leftTrousers",

    CAPE = "cape"
}

export const SKIN_PARTS: SkinPart[] = Object.values(SkinPart);
